import React from 'react';
import { Navigate } from 'react-router-dom';
import routes from '../config/routes';
import { useEnterpriseAuth } from '../context/EnterpriseAuthContext';
import { CircularProgress, Box } from '@mui/material';

export default function ASCProtectedRoute({ user, children }) {
  const { isLoading } = useEnterpriseAuth();
  
  // Show loading spinner while auth is being checked
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  // Check if user exists and has ASC mode
  if (!user) {
    // Double-check localStorage to prevent race conditions
    const hasToken = localStorage.getItem('token');
    if (!hasToken) {
      return (
        <Navigate to={routes.ascLogin()} replace state={{ message: 'Please log in to access this area.' }} />
      );
    }
    // If we have a token but no user yet, show loading
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (user.mode !== 'asc') {
    return (
      <Navigate
        to={routes.ascLogin()}
        replace
        state={{ message: 'Please log in with ASC credentials to access this area.' }}
      />
    );
  }

  // User is authenticated with ASC mode
  return children;
}
